var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-radio',{ref:"bsRadioButton",staticClass:"d-flex mh-0 w-100 pl-0 gmb-radio-button",attrs:{"name":_vm.name,"size":"sm","value":_vm.value},on:{"input":(bsRadioButtonGroupNewActivatedValue) =>
      _vm.onActivatedValueChanged(bsRadioButtonGroupNewActivatedValue)},nativeOn:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }